import React from 'react';
import { useRealtime } from '../../contexts/RealtimeContext';
import TeacherSettlementManagement from '../../components/coaching/TeacherSettlementManagement';
import { isCoachingAdmin as checkIsCoachingAdmin } from '../../utils/rbac';

const TeacherSettlementsPage = () => {
  const { userProfile, currentUser } = useRealtime();
  const isCoachingAdmin = checkIsCoachingAdmin(userProfile, currentUser);
  
  // Determine coaching ID - use from profile or default for admins
  const coachingId = isCoachingAdmin ? 
                    (userProfile?.coachingId || currentUser?.uid) : 
                    (userProfile?.role === 'admin' ? 'test-coaching-id' : null);

  console.log('TeacherSettlementsPage - coachingId:', coachingId, 'userProfile:', userProfile, 'role:', userProfile?.role);

  // Show loading if user profile is not loaded yet
  if (!userProfile) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  // Check permissions
  if (!coachingId || (!isCoachingAdmin && userProfile?.role !== 'admin' && userProfile?.role !== 'superadmin')) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
        <div className="text-center py-12">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            Access Denied
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            You don't have permission to access teacher settlements.
          </p>
        </div>
      </div>
    );
  }

  return <TeacherSettlementManagement coachingId={coachingId} />;
};

export default TeacherSettlementsPage;